import React from "react";
import { makeStyles } from "@material-ui/core/styles";

function TestimonialTextContent({ textContent, isAlignCenter}) {

  // Font-color
  const useStyle = makeStyles({
    root: {
      "& .testimonial-title": {
        textAlign: isAlignCenter ? "center" : "left",
        color: textContent.titleColor + " !important",
      },
      "& .testimonial-description": {
        textAlign: isAlignCenter ? "center" : "left",
        color: textContent.descriptionColor + " !important",
      },
    },
  });
  const classes = useStyle();
  return (
    <div
      className={"testimonial-text-content " + classes.root}
    >
      <Title title={textContent.title} useH1={textContent.useH1}/>
      
      <p className="testimonial-description">{textContent.description}</p>
    </div>
  );
}
// H1==H2
const Title = ({ title, useH1 }) => {
  return useH1 ? <h1 className="testimonial-title">{title}</h1> : <h2 className="testimonial-title">{title}</h2>;
};
export default TestimonialTextContent;
